import React, { useState } from "react";
import Modal from "../Modal";
import { Link } from "react-router-dom";
import { reportCardDetails } from "../../../../redux/actions/report";
import { useDispatch } from "react-redux";
import Pagination from "react-js-pagination";
import "./style.css";

const Table = ({ List, activePage, handlePageChange, setReload }) => {

  const dispatch = useDispatch();

  const [show, setShow] = useState(false);
  const [reportData, setReportData] = useState({})

  const handleClose = () => setShow(false);

  const handleEdit = (kidId) => {
    dispatch(reportCardDetails({ kidId }, data => {
      const reportData = data?.categoryDetails?.map(item => ({
        categoryId: item?.categoryId,
        categoryName: item?.categoryName,
        percentage: item?.percentage,
        comments: item?.comments,
        feedback: item?.recentComment,
        isEdit: false
      }))
      const payload = {
        kidId,
        kidName: data?.kidName,
        reportcardDetails: reportData,
        overallFeedback: data?.overallRecentComment,
        overallPercentage: data?.overallPercentage
      }
      setReportData(payload);
      setShow(true)
    }))
  }

  return (
    <div className="report-table">
      <div className="table-data">
        <table className="table  table-inr report mb-0">
          <thead>
            <tr className="border-0">
              <th className="border-bottom-0 text-center">Student name</th>
              <th className="border-bottom-0 text-center">Roll No.</th>
              <th className="border-bottom-0 text-center">
                Overall Percentage Marks
              </th>
              <th className="border-bottom-0 text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {List?.data?.map((item, index) => {
              return (<tr key={index}>
                <td>{item?.kidName}</td>
                <td>{item?.roleNo}</td>
                <td>{Math.ceil(item?.score)}%</td>
                <td className="d-flex align-center justify-content-center">
                  <button onClick={() => handleEdit(item?.kidId)} className="btn btns edit-btn m-0">Edit</button>
                  <Link to='/view-reportcard' state={{ kidId: item?.kidId }} className="btn btns view-btn m-0">
                    View Report Card
                  </Link>
                </td>
              </tr>)
            })}
          </tbody>
        </table>
      </div>
      {List?.pagination_info &&
        <div className="pagination-bar w-100 d-flex justify-content-between border-top-0">
          <p className="counting mb-0">{activePage} out of {List?.pagination_info?.total_pages}</p>
          <nav aria-label="Page navigation example">
            <Pagination
              activePage={activePage}
              itemsCountPerPage={List?.pagination_info?.page_size}
              totalItemsCount={List?.pagination_info?.total_elements}
              pageRangeDisplayed={5}
              innerClass="pagination mb-0 p-0"
              itemClass="page-item"
              linkClass="page-link"
              onChange={handlePageChange}
            />
          </nav>
        </div>
      }
      {show && <Modal show={show} handleClose={handleClose} reportData={reportData} setReload={setReload} />}
    </div>
  );
};

export default Table;
